export enum ProviderInsightsCompetencyCategory {
  ATTUNEMENT_AND_RAPPORT = 'attunementAndRapport',
  CULTURALLY_RESPONSIVE = 'culturallyResponsive',
  RISK_MANAGEMENT = 'riskManagement',
  SESSION_ADMINISTRATION = 'sessionAdministration',
  TREATMENT_PLANNING = 'treatmentPlanning',
}

export enum ProviderInsightsCompetencyAreaName {
  ATTUNEMENT_AND_RAPPORT = 'ATTUNEMENT_AND_RAPPORT',
  CULTURALLY_RESPONSIVE = 'CULTURALLY_RESPONSIVE',
  RISK_MANAGEMENT = 'RISK_MANAGEMENT',
  SESSION_ADMINISTRATION = 'SESSION_ADMINISTRATION',
  TREATMENT_PLANNING = 'TREATMENT_PLANNING',
}

export const ProviderInsightsCompetencyAreaLabels: Record<ProviderInsightsCompetencyCategory, string> = {
  [ProviderInsightsCompetencyCategory.ATTUNEMENT_AND_RAPPORT]: 'Therapeutic relationship',
  [ProviderInsightsCompetencyCategory.CULTURALLY_RESPONSIVE]: 'Culturally responsive care',
  [ProviderInsightsCompetencyCategory.RISK_MANAGEMENT]: 'Risk management',
  [ProviderInsightsCompetencyCategory.SESSION_ADMINISTRATION]: 'Session administration',
  [ProviderInsightsCompetencyCategory.TREATMENT_PLANNING]: 'Treatment planning',
}

export enum ProviderInsightsSubAreaName {
  RISK_MANAGEMENT_PROACTIVE = 'RISK_MANAGEMENT_PROACTIVE',
  RISK_MANAGEMENT_ADDRESSES = 'RISK_MANAGEMENT_ADDRESSES',
  RISK_MANAGEMENT_ASSESS = 'RISK_MANAGEMENT_ASSESS',
  RISK_MANAGEMENT_COMPREHENSIVE = 'RISK_MANAGEMENT_COMPREHENSIVE',
  RISK_MANAGEMENT_SAFETY_PLAN = 'RISK_MANAGEMENT_SAFETY_PLAN',
  RISK_MANAGEMENT_RESOURCES = 'RISK_MANAGEMENT_RESOURCES',
  RISK_MANAGEMENT_SUPPORT_SYSTEM = 'RISK_MANAGEMENT_SUPPORT_SYSTEM',
  RISK_MANAGEMENT_NORMALIZE = 'RISK_MANAGEMENT_NORMALIZE',
  RISK_MANAGEMENT_COMMUNICATE_RATIONALE = 'RISK_MANAGEMENT_COMMUNICATE_RATIONALE',
  RISK_MANAGEMENT_LEGAL = 'RISK_MANAGEMENT_LEGAL',
  RISK_MANAGEMENT_MOTIVATION = 'RISK_MANAGEMENT_MOTIVATION',
  RISK_MANAGEMENT_INTERVENTIONS = 'RISK_MANAGEMENT_INTERVENTIONS',
  RISK_MANAGEMENT_PRACTICES = 'RISK_MANAGEMENT_PRACTICES',
  RISK_MANAGEMENT_DOCUMENTS = 'RISK_MANAGEMENT_DOCUMENTS',
  TREATMENT_PLANNING_QUESTIONING = 'TREATMENT_PLANNING_QUESTIONING',
  TREATMENT_PLANNING_REFERENCES = 'TREATMENT_PLANNING_REFERENCES',
  TREATMENT_PLANNING_INTERVENTIONS = 'TREATMENT_PLANNING_INTERVENTIONS',
  TREATMENT_PLANNING_SYMPTOM_PRESENTATION = 'TREATMENT_PLANNING_SYMPTOM_PRESENTATION',
  TREATMENT_PLANNING_MEASURE_COMPLETION = 'TREATMENT_PLANNING_MEASURE_COMPLETION',
  TREATMENT_PLANNING_WHY = 'TREATMENT_PLANNING_WHY',
  TREATMENT_PLANNING_HOMEWORK_SUGGESTIONS = 'TREATMENT_PLANNING_HOMEWORK_SUGGESTIONS',
  TREATMENT_PLANNING_DIGITAL_EXERCISES = 'TREATMENT_PLANNING_DIGITAL_EXERCISES',
  TREATMENT_PLANNING_HOPE = 'TREATMENT_PLANNING_HOPE',
  TREATMENT_PLANNING_ACKNOWLEDGE_WORK = 'TREATMENT_PLANNING_ACKNOWLEDGE_WORK',
  TREATMENT_PLANNING_GRADUATING = 'TREATMENT_PLANNING_GRADUATING',
  CULTURALLY_RESPONSIVE_OPENNESS = 'CULTURALLY_RESPONSIVE_OPENNESS',
  CULTURALLY_RESPONSIVE_IDENTITY = 'CULTURALLY_RESPONSIVE_IDENTITY',
  CULTURALLY_RESPONSIVE_TAILORS = 'CULTURALLY_RESPONSIVE_TAILORS',
  CULTURALLY_RESPONSIVE_GATHER_KNOWLEDGE = 'CULTURALLY_RESPONSIVE_GATHER_KNOWLEDGE',
  CULTURALLY_RESPONSIVE_IN_PLAN = 'CULTURALLY_RESPONSIVE_IN_PLAN',
  CULTURALLY_RESPONSIVE_REFLECTIONS = 'CULTURALLY_RESPONSIVE_REFLECTIONS',
  CULTURALLY_RESPONSIVE_SYSTEMIC = 'CULTURALLY_RESPONSIVE_SYSTEMIC',
  ATTUNEMENT_AND_RAPPORT_BOUNDARIES = 'ATTUNEMENT_AND_RAPPORT_BOUNDARIES',
  ATTUNEMENT_AND_RAPPORT_SELF_DISCLOSURE = 'ATTUNEMENT_AND_RAPPORT_SELF_DISCLOSURE',
  ATTUNEMENT_AND_RAPPORT_ACTIVE_LISTENING = 'ATTUNEMENT_AND_RAPPORT_ACTIVE_LISTENING',
  ATTUNEMENT_AND_RAPPORT_QUESTIONS = 'ATTUNEMENT_AND_RAPPORT_QUESTIONS',
  ATTUNEMENT_AND_RAPPORT_COLLABORATIVE = 'ATTUNEMENT_AND_RAPPORT_COLLABORATIVE',
  ATTUNEMENT_AND_RAPPORT_AFFIRM = 'ATTUNEMENT_AND_RAPPORT_AFFIRM',
  ATTUNEMENT_AND_RAPPORT_VALIDATES = 'ATTUNEMENT_AND_RAPPORT_VALIDATES',
  ATTUNEMENT_AND_RAPPORT_RESISTANCE = 'ATTUNEMENT_AND_RAPPORT_RESISTANCE',
  ATTUNEMENT_AND_RAPPORT_CHALLENGES = 'ATTUNEMENT_AND_RAPPORT_CHALLENGES',
  ATTUNEMENT_AND_RAPPORT_INTEREST = 'ATTUNEMENT_AND_RAPPORT_INTEREST',
  ATTUNEMENT_AND_RAPPORT_FEEDBACK = 'ATTUNEMENT_AND_RAPPORT_FEEDBACK',
  ATTUNEMENT_AND_RAPPORT_NON_VERBALS = 'ATTUNEMENT_AND_RAPPORT_NON_VERBALS',
}

export const ProviderInsightsSubAreaLabels: Record<ProviderInsightsSubAreaName, string> = {
  [ProviderInsightsSubAreaName.RISK_MANAGEMENT_PROACTIVE]: 'screens for risk',
  [ProviderInsightsSubAreaName.RISK_MANAGEMENT_ADDRESSES]: 'assesses risk fluently',
  [ProviderInsightsSubAreaName.RISK_MANAGEMENT_ASSESS]: 'conducts risk assessment',
  [ProviderInsightsSubAreaName.RISK_MANAGEMENT_COMPREHENSIVE]: 'comprehensive risk assessment',
  [ProviderInsightsSubAreaName.RISK_MANAGEMENT_SAFETY_PLAN]: 'develops safety plan',
  [ProviderInsightsSubAreaName.RISK_MANAGEMENT_RESOURCES]: 'provides crisis resources',
  [ProviderInsightsSubAreaName.RISK_MANAGEMENT_SUPPORT_SYSTEM]: 'involves support systems',
  [ProviderInsightsSubAreaName.RISK_MANAGEMENT_NORMALIZE]: 'normalizes risk conversation',
  [ProviderInsightsSubAreaName.RISK_MANAGEMENT_COMMUNICATE_RATIONALE]: 'explains safety plan rationale',
  [ProviderInsightsSubAreaName.RISK_MANAGEMENT_LEGAL]: 'follows legal/ethical mandates',
  [ProviderInsightsSubAreaName.RISK_MANAGEMENT_MOTIVATION]: 'builds motivation to address risk',
  [ProviderInsightsSubAreaName.RISK_MANAGEMENT_INTERVENTIONS]: 'targets risk symptoms',
  [ProviderInsightsSubAreaName.RISK_MANAGEMENT_PRACTICES]: 'selects risk-related practices',
  [ProviderInsightsSubAreaName.RISK_MANAGEMENT_DOCUMENTS]: 'documents accurately and comprehensively',
  [ProviderInsightsSubAreaName.TREATMENT_PLANNING_QUESTIONING]: 'maintains focus on goals',
  [ProviderInsightsSubAreaName.TREATMENT_PLANNING_REFERENCES]: 'references previous goals',
  [ProviderInsightsSubAreaName.TREATMENT_PLANNING_INTERVENTIONS]: 'selects EBT interventions',
  [ProviderInsightsSubAreaName.TREATMENT_PLANNING_SYMPTOM_PRESENTATION]: 'references assessment scores',
  [ProviderInsightsSubAreaName.TREATMENT_PLANNING_MEASURE_COMPLETION]: 'discusses measure completion strategies',
  [ProviderInsightsSubAreaName.TREATMENT_PLANNING_WHY]: 'explains treatment rationale',
  [ProviderInsightsSubAreaName.TREATMENT_PLANNING_HOMEWORK_SUGGESTIONS]: 'suggests relevant interventions',
  [ProviderInsightsSubAreaName.TREATMENT_PLANNING_DIGITAL_EXERCISES]: 'explains digital tools',
  [ProviderInsightsSubAreaName.TREATMENT_PLANNING_HOPE]: 'instills hope',
  [ProviderInsightsSubAreaName.TREATMENT_PLANNING_ACKNOWLEDGE_WORK]: 'acknowledges client effort',
  [ProviderInsightsSubAreaName.TREATMENT_PLANNING_GRADUATING]: 'discusses graduation effectively',
  [ProviderInsightsSubAreaName.CULTURALLY_RESPONSIVE_OPENNESS]: 'explores cultural context',
  [ProviderInsightsSubAreaName.CULTURALLY_RESPONSIVE_IDENTITY]: 'acknowledges cultural experiences',
  [ProviderInsightsSubAreaName.CULTURALLY_RESPONSIVE_TAILORS]: 'tailors interventions culturally',
  [ProviderInsightsSubAreaName.CULTURALLY_RESPONSIVE_GATHER_KNOWLEDGE]: 'seeks cultural knowledge',
  [ProviderInsightsSubAreaName.CULTURALLY_RESPONSIVE_IN_PLAN]: 'integrates cultural variables',
  [ProviderInsightsSubAreaName.CULTURALLY_RESPONSIVE_REFLECTIONS]: 'invites cultural discussion',
  [ProviderInsightsSubAreaName.CULTURALLY_RESPONSIVE_SYSTEMIC]: 'explores systemic factors',
  [ProviderInsightsSubAreaName.ATTUNEMENT_AND_RAPPORT_BOUNDARIES]: 'maintains therapeutic boundaries',
  [ProviderInsightsSubAreaName.ATTUNEMENT_AND_RAPPORT_SELF_DISCLOSURE]: 'uses appropriate self-disclosure',
  [ProviderInsightsSubAreaName.ATTUNEMENT_AND_RAPPORT_ACTIVE_LISTENING]: 'demonstrates active listening',
  [ProviderInsightsSubAreaName.ATTUNEMENT_AND_RAPPORT_QUESTIONS]: 'asks open-ended questions',
  [ProviderInsightsSubAreaName.ATTUNEMENT_AND_RAPPORT_COLLABORATIVE]: 'demonstrates collaborative stance',
  [ProviderInsightsSubAreaName.ATTUNEMENT_AND_RAPPORT_AFFIRM]: 'uses affirming tone',
  [ProviderInsightsSubAreaName.ATTUNEMENT_AND_RAPPORT_VALIDATES]: 'reflects back feelings',
  [ProviderInsightsSubAreaName.ATTUNEMENT_AND_RAPPORT_RESISTANCE]: 'navigates client resistance',
  [ProviderInsightsSubAreaName.ATTUNEMENT_AND_RAPPORT_CHALLENGES]: 'effectively challenges client',
  [ProviderInsightsSubAreaName.ATTUNEMENT_AND_RAPPORT_INTEREST]: 'shows genuine interest',
  [ProviderInsightsSubAreaName.ATTUNEMENT_AND_RAPPORT_FEEDBACK]: 'seeks client feedback',
  [ProviderInsightsSubAreaName.ATTUNEMENT_AND_RAPPORT_NON_VERBALS]: 'tracks client non-verbals',
}

export const ProviderInsightsSubAreaGerundFormatLabels: Record<ProviderInsightsSubAreaName, string> = {
  [ProviderInsightsSubAreaName.RISK_MANAGEMENT_PROACTIVE]: 'screening for risk',
  [ProviderInsightsSubAreaName.RISK_MANAGEMENT_ADDRESSES]: 'assessing risk fluently',
  [ProviderInsightsSubAreaName.RISK_MANAGEMENT_ASSESS]: 'conducting risk assessment',
  [ProviderInsightsSubAreaName.RISK_MANAGEMENT_COMPREHENSIVE]: 'completing comprehensive risk assessment',
  [ProviderInsightsSubAreaName.RISK_MANAGEMENT_SAFETY_PLAN]: 'developing safety plan',
  [ProviderInsightsSubAreaName.RISK_MANAGEMENT_RESOURCES]: 'providing crisis resources',
  [ProviderInsightsSubAreaName.RISK_MANAGEMENT_SUPPORT_SYSTEM]: 'involving support systems',
  [ProviderInsightsSubAreaName.RISK_MANAGEMENT_NORMALIZE]: 'normalizing risk conversation',
  [ProviderInsightsSubAreaName.RISK_MANAGEMENT_COMMUNICATE_RATIONALE]: 'explaining safety plan rationale',
  [ProviderInsightsSubAreaName.RISK_MANAGEMENT_LEGAL]: 'following legal/ethical mandates',
  [ProviderInsightsSubAreaName.RISK_MANAGEMENT_MOTIVATION]: 'building motivation to address risk',
  [ProviderInsightsSubAreaName.RISK_MANAGEMENT_INTERVENTIONS]: 'targeting risk symptoms',
  [ProviderInsightsSubAreaName.RISK_MANAGEMENT_PRACTICES]: 'selecting risk-related practices',
  [ProviderInsightsSubAreaName.RISK_MANAGEMENT_DOCUMENTS]: 'documenting accurately and comprehensively',
  [ProviderInsightsSubAreaName.TREATMENT_PLANNING_QUESTIONING]: 'maintaining focus on goals',
  [ProviderInsightsSubAreaName.TREATMENT_PLANNING_REFERENCES]: 'referencing previous goals',
  [ProviderInsightsSubAreaName.TREATMENT_PLANNING_INTERVENTIONS]: 'selecting EBT interventions',
  [ProviderInsightsSubAreaName.TREATMENT_PLANNING_SYMPTOM_PRESENTATION]: 'referencing assessment scores',
  [ProviderInsightsSubAreaName.TREATMENT_PLANNING_MEASURE_COMPLETION]: 'discussing measure completion strategies',
  [ProviderInsightsSubAreaName.TREATMENT_PLANNING_WHY]: 'explaining treatment rationale',
  [ProviderInsightsSubAreaName.TREATMENT_PLANNING_HOMEWORK_SUGGESTIONS]: 'suggesting relevant interventions',
  [ProviderInsightsSubAreaName.TREATMENT_PLANNING_DIGITAL_EXERCISES]: 'explaining digital tools',
  [ProviderInsightsSubAreaName.TREATMENT_PLANNING_HOPE]: 'instilling hope',
  [ProviderInsightsSubAreaName.TREATMENT_PLANNING_ACKNOWLEDGE_WORK]: 'acknowledging client effort',
  [ProviderInsightsSubAreaName.TREATMENT_PLANNING_GRADUATING]: 'discussing graduation effectively',
  [ProviderInsightsSubAreaName.CULTURALLY_RESPONSIVE_OPENNESS]: 'exploring cultural context',
  [ProviderInsightsSubAreaName.CULTURALLY_RESPONSIVE_IDENTITY]: 'acknowledging cultural experiences',
  [ProviderInsightsSubAreaName.CULTURALLY_RESPONSIVE_TAILORS]: 'tailoring interventions culturally',
  [ProviderInsightsSubAreaName.CULTURALLY_RESPONSIVE_GATHER_KNOWLEDGE]: 'seeking cultural knowledge',
  [ProviderInsightsSubAreaName.CULTURALLY_RESPONSIVE_IN_PLAN]: 'integrating cultural variables',
  [ProviderInsightsSubAreaName.CULTURALLY_RESPONSIVE_REFLECTIONS]: 'inviting cultural discussion',
  [ProviderInsightsSubAreaName.CULTURALLY_RESPONSIVE_SYSTEMIC]: 'exploring systemic factors',
  [ProviderInsightsSubAreaName.ATTUNEMENT_AND_RAPPORT_BOUNDARIES]: 'maintaining therapeutic boundaries',
  [ProviderInsightsSubAreaName.ATTUNEMENT_AND_RAPPORT_SELF_DISCLOSURE]: 'using appropriate self-disclosure',
  [ProviderInsightsSubAreaName.ATTUNEMENT_AND_RAPPORT_ACTIVE_LISTENING]: 'demonstrating active listening',
  [ProviderInsightsSubAreaName.ATTUNEMENT_AND_RAPPORT_QUESTIONS]: 'asking open-ended questions',
  [ProviderInsightsSubAreaName.ATTUNEMENT_AND_RAPPORT_COLLABORATIVE]: 'demonstrating collaborative stance',
  [ProviderInsightsSubAreaName.ATTUNEMENT_AND_RAPPORT_AFFIRM]: 'using affirming tone',
  [ProviderInsightsSubAreaName.ATTUNEMENT_AND_RAPPORT_VALIDATES]: 'reflecting back feelings',
  [ProviderInsightsSubAreaName.ATTUNEMENT_AND_RAPPORT_RESISTANCE]: 'navigating client resistance',
  [ProviderInsightsSubAreaName.ATTUNEMENT_AND_RAPPORT_CHALLENGES]: 'effectively challenging client',
  [ProviderInsightsSubAreaName.ATTUNEMENT_AND_RAPPORT_INTEREST]: 'showing genuine interest',
  [ProviderInsightsSubAreaName.ATTUNEMENT_AND_RAPPORT_FEEDBACK]: 'seeking client feedback',
  [ProviderInsightsSubAreaName.ATTUNEMENT_AND_RAPPORT_NON_VERBALS]: 'tracking client non-verbals',
}

export interface CareInsightsZendeskArticle {
  id: string
  title: string
  url: string
  relatedSubAreas: ProviderInsightsSubAreaName[]
}

export enum InsightType {
  STRENGTH = 'strength',
  OPPORTUNITY = 'opportunity',
}

export const BestAndWorstInsightStrings: Record<ProviderInsightsCompetencyCategory, Record<InsightType, string[]>> = {
  [ProviderInsightsCompetencyCategory.RISK_MANAGEMENT]: {
    strength: [
      'There was a clear and reliable focus on [SKILL] for [Name].',
      'Your approach to [SKILL] was demonstrated consistently and clearly with [Name].',
      "You adeptly used [SKILL] in your work with [Name], given [Name]'s endorsement of symptoms of risk in the previous session.",
      'You prioritized [SKILL] in your work with [Name].',
      'You consistently used [SKILL] in your approach with [Name].',
      'Your use of [SKILL] was evident in your work with [Name].',
      'Your commitment to [SKILL] was apparent in your work with [Name]. Often the use of [SKILL] can help set a strong foundation in care.',
      'The application of [SKILL] is clearly present in your work with [Name].',
    ],
    opportunity: [
      'You did not complete [SKILL] in your work with [Name].',
      'You did not consistently apply [SKILL] in your work with [Name].',
    ],
  },
  [ProviderInsightsCompetencyCategory.TREATMENT_PLANNING]: {
    strength: [
      'There was a clear emphasis on [SKILL] in your work with [Name].',
      'Your work reflected a thoughtful integration of [SKILL] for [Name].',
      'You demonstrated a strong ability in [SKILL] in your work with [Name].',
      'You demonstrated a strong commitment to [SKILL] in your approach with [Name].',
      'Your use of [SKILL] maintained the momentum of care for [Name].',
    ],
    opportunity: [
      'You might consider integrating [SKILL] into your care for [Name].',
      'Emphasizing [SKILL] could be a point of consideration for [Name].',
      'Your approach to care for [Name] has not incorporated [SKILL] as of yet, this might be a point of consideration.',
      'You might consider further prioritizing [SKILL] in the treatment for [Name].',
    ],
  },
  [ProviderInsightsCompetencyCategory.CULTURALLY_RESPONSIVE]: {
    strength: [
      'Your practice shows a proactive effort toward [SKILL] for [Name].',
      'There is a deep level of sensitivity in your work on [SKILL] with [Name].',
      "You've been effective in [SKILL], which brings additional nuance for [Name].",
      'It is clear that [SKILL] was prioritized in your work with [Name].',
      'You demonstrate consistent use of [SKILL] with [Name].',
      'Your inclusion of [SKILL] provides a more comprehensive understanding of [Name].',
      'Your use of [SKILL] reflects a high degree of cultural humility with [Name].',
      'You show a strong handle on [SKILL] in your work with [Name].',
    ],
    opportunity: [
      'There may be room to further explore the context of [Name] by [SKILL].',
      'It could be helpful to deepen the cultural lens of your conceptualization with [Name] through [SKILL].',
      'Consider a more active incorporation of [SKILL] into your work with [Name].',
      'A broader approach to [SKILL] might reveal new nuances for [Name].',
      'You may consider [SKILL] to further refine your approach to care with [Name].',
      'You might look for ways to prioritize [SKILL] when evaluating the needs of [Name].',
    ],
  },
  [ProviderInsightsCompetencyCategory.ATTUNEMENT_AND_RAPPORT]: {
    strength: [
      'There is a high level of attunement shown through [SKILL] with [Name].',
      'Your use of [SKILL] was impressive with [Name].',
      "You've used [SKILL] with great consistency to support the relationship with [Name].",
      'You demonstrate a collaborative and steady stance by [SKILL] with [Name].',
      'Your ability to incorporate [SKILL] is a strong component of your presence with [Name].',
      'You show a strong handle on [SKILL] with [Name].',
      'A focus on [SKILL] is an effective part of your engagement with [Name].',
    ],
    opportunity: [
      'It could be valuable to lean more into [SKILL] to support your work with [Name].',
      'There may be an opportunity to increase the focus on [SKILL] during sessions with [Name].',
      'Consider how [SKILL] might help you navigate your work with [Name].',
      'A more collaborative stance might be facilitated by [SKILL] with [Name].',
      'You might find that [SKILL] helps deepen the therapeutic engagement with [Name].',
      'The rapport with [Name] could be further supported by a focus on [SKILL].',
    ],
  },
  [ProviderInsightsCompetencyCategory.SESSION_ADMINISTRATION]: {
    strength: [],
    opportunity: [],
  },
}

export const CareInsightsZendeskArticles: Record<ProviderInsightsCompetencyCategory, CareInsightsZendeskArticle[]> = {
  [ProviderInsightsCompetencyCategory.RISK_MANAGEMENT]: [
    {
      id: 'imminent_risk_protocol',
      title: 'Protocol for Situations Involving Imminent Risk',
      url: 'https://bct-lyrahealth.zendesk.com/hc/en-us/articles/360044627553-Protocol-for-Situations-Involving-Imminent-Risk',
      relatedSubAreas: [ProviderInsightsSubAreaName.RISK_MANAGEMENT_PROACTIVE],
    },
    {
      id: 'crisis_resources',
      title: 'Crisis and Mental Health Resources',
      url: 'https://bct-lyrahealth.zendesk.com/hc/en-us/articles/1500010833882-Crisis-and-Mental-Health-Resources',
      relatedSubAreas: [ProviderInsightsSubAreaName.RISK_MANAGEMENT_RESOURCES],
    },
    {
      id: 'suicidal_thoughts_self_injury',
      title: 'Resources for Working with Clients with Suicidal Thoughts and Behaviors and Self-injury',
      url: 'https://bct-lyrahealth.zendesk.com/hc/en-us/articles/36818338062483-Resources-for-Working-with-Clients-with-Suicidal-Thoughts-and-Behaviors-and-Self-injury',
      relatedSubAreas: [ProviderInsightsSubAreaName.RISK_MANAGEMENT_ASSESS],
    },
  ],
  [ProviderInsightsCompetencyCategory.TREATMENT_PLANNING]: [
    {
      id: 'goal_setting',
      title: 'Goal Setting',
      url: 'https://bct-lyrahealth.zendesk.com/hc/en-us/articles/4402937459859-Goal-Setting',
      relatedSubAreas: [
        ProviderInsightsSubAreaName.TREATMENT_PLANNING_QUESTIONING,
        ProviderInsightsSubAreaName.TREATMENT_PLANNING_REFERENCES,
      ],
    },
    {
      id: 'measurement_based_care_therapy',
      title: 'Using Measurement-Based Care in Blended Care Therapy',
      url: 'https://bct-lyrahealth.zendesk.com/hc/en-us/articles/4402937704467-Using-Measurement-Based-Care-in-Blended-Care-Therapy-',
      relatedSubAreas: [ProviderInsightsSubAreaName.TREATMENT_PLANNING_SYMPTOM_PRESENTATION],
    },
    {
      id: 'problem_solving',
      title: 'Problem Solving',
      url: 'https://bct-lyrahealth.zendesk.com/hc/en-us/articles/360035874713-Problem-Solving',
      relatedSubAreas: [ProviderInsightsSubAreaName.TREATMENT_PLANNING_MEASURE_COMPLETION],
    },
    {
      id: 'graduation_preparation',
      title:
        'Preparing for Graduation: Empowering Clients to Independently Use Therapy Skills Successfully in Difficult Situations',
      url: 'https://bct-lyrahealth.zendesk.com/hc/en-us/articles/4639675438355',
      relatedSubAreas: [ProviderInsightsSubAreaName.TREATMENT_PLANNING_GRADUATING],
    },
    {
      id: 'mbc_dashboard',
      title: 'Measurement-Based Care (MBC) Dashboard',
      url: 'https://bct-lyrahealth.zendesk.com/hc/en-us/articles/4411907723283-Measurement-Based-Care-MBC-Dashboard',
      relatedSubAreas: [],
    },
    {
      id: 'presession_assessment_completion',
      title: 'Enhancing Completion of Pre-session Assessments',
      url: 'https://bct-lyrahealth.zendesk.com/hc/en-us/articles/4412231975827-Enhancing-Completion-of-Pre-session-Assessments',
      relatedSubAreas: [],
    },
    {
      id: 'platform_engagement_metric',
      title: 'Platform Engagement Metric',
      url: 'https://bct-lyrahealth.zendesk.com/hc/en-us/articles/10189970197651-Platform-Engagement-Metric',
      relatedSubAreas: [],
    },
  ],
  [ProviderInsightsCompetencyCategory.CULTURALLY_RESPONSIVE]: [
    {
      id: 'culturally_responsive_care',
      title: 'Culturally Responsive Care',
      url: 'https://bct-lyrahealth.zendesk.com/hc/en-us/sections/4408276832659-Culturally-Responsive-Care',
      relatedSubAreas: [ProviderInsightsSubAreaName.CULTURALLY_RESPONSIVE_SYSTEMIC],
    },
    {
      id: 'crc_alliance_questionnaire',
      title: 'CRC Alliance Questionnaire',
      url: 'https://bct-lyrahealth.zendesk.com/hc/en-us/articles/5948441059731-CRC-Alliance-Questionnaire',
      relatedSubAreas: [],
    },
  ],
  [ProviderInsightsCompetencyCategory.SESSION_ADMINISTRATION]: [
    {
      id: 'first_session_guide',
      title: 'First Session Guide',
      url: 'https://bct-lyrahealth.zendesk.com/hc/en-us/articles/360033897994-First-Session-Guide',
      relatedSubAreas: [],
    },
  ],
  [ProviderInsightsCompetencyCategory.ATTUNEMENT_AND_RAPPORT]: [
    {
      id: 'sustain_talk',
      title: 'Addressing Sustain Talk with Clients',
      url: 'https://bct-lyrahealth.zendesk.com/hc/en-us/articles/360047705914-Addressing-Sustain-Talk-with-Clients',
      relatedSubAreas: [ProviderInsightsSubAreaName.ATTUNEMENT_AND_RAPPORT_RESISTANCE],
    },
    {
      id: 'client_confidence_change',
      title: 'Strengthening Clients Confidence to Change',
      url: 'https://bct-lyrahealth.zendesk.com/hc/en-us/articles/4948321947667',
      relatedSubAreas: [ProviderInsightsSubAreaName.ATTUNEMENT_AND_RAPPORT_CHALLENGES],
    },
    {
      id: 'alliance',
      title: 'Alliance',
      url: 'https://bct-lyrahealth.zendesk.com/hc/en-us/articles/360035872673-Alliance',
      relatedSubAreas: [],
    },
  ],
}
